import EditTeamMember from './EditTeamMember';

export default EditTeamMember;
